(function () {
  function initFloatingContactSidebar(root) {
    var wechatBtn = root.querySelector("[data-fcs-wechat-btn]");
    var wechatPanel = root.querySelector("[data-fcs-wechat-panel]");

    if (!wechatBtn || !wechatPanel) return;

    function open() {
      wechatBtn.classList.add("is-open");
      wechatBtn.setAttribute("aria-expanded", "true");
    }

    function close() {
      wechatBtn.classList.remove("is-open");
      wechatBtn.setAttribute("aria-expanded", "false");
    }

    function toggle() {
      var isOpen = wechatBtn.classList.contains("is-open");
      if (isOpen) close();
      else open();
    }

    // Detect if device is touch-enabled
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Hover open for desktop mouse users only
    if (!isTouchDevice) {
      wechatBtn.addEventListener("mouseenter", open);
      wechatBtn.addEventListener("mouseleave", close);
    }

    // Click toggle (touch devices / explicit control)
    wechatBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });

    // Close when clicking outside
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) close();
    });

    // Close on ESC
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-fcs]").forEach(initFloatingContactSidebar);
  });

  // Shopify theme editor (optional compatibility)
  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll("[data-fcs]").forEach(initFloatingContactSidebar);
  });
})();
